/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LabStation } from './LabStation';

export type Block = {
    readonly id?: number;
    readonly specimen_id?: number;
    name: string | null;
    readonly lab_station?: LabStation | null;
    lis_state?: Block.lis_state | null;
    piece_count?: Block.piece_count | null;
    readonly created_at?: string;
    readonly updated_at?: string;
}

export namespace Block {

    export enum lis_state {
        UNPROCESSED = 'unprocessed',
        RACKED = 'racked',
        PROCESSED = 'processed',
        COOLING = 'cooling',
        EMBEDDED = 'embedded',
    }

    export enum piece_count {
        _0 = '0',
        _1 = '1',
        _2 = '2',
        _3 = '3',
        _4 = '4',
        _5 = '5',
        _1F = '1F',
        _2F = '2F',
        _3F = '3F',
        _4F = '4F',
        _5F = '5F',
        F = 'F',
    }


}
